import { cx } from '@/utils/cx'
import './DividerWithText.css'

interface DividerWithTextProps {
  text: string
  margin?: string
  width?: string
}

export const DividerWithText = ({ text, margin, width }: DividerWithTextProps) => (
  <div
    className={cx(
      'divider-with-text',
      width === '100%' && 'divider-with-text--w-full',
      margin === '30px 0' && 'divider-with-text--m-30-0'
    )}
  >
    <div className="divider-with-text__line" />
    <span className="divider-with-text__text">{text}</span>
    <div className="divider-with-text__line" />
  </div>
)
